import { render, staticRenderFns } from "./Verhogingen.vue?vue&type=template&id=1275cae8&"
import script from "./Verhogingen.vue?vue&type=script&lang=ts&"
export * from "./Verhogingen.vue?vue&type=script&lang=ts&"
import style0 from "./Verhogingen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports